export default __webpack_public_path__ + "static/media/ScopeHaiLogo-two-color.2fa2c839.png";